"use client";
import Link from "next/link";
import { DisplayMarkdown } from "@padi/xui/display-markdown";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import { COOKIE, PRIVACY, RETURN, SHIPPING } from "./policies";

const sections = [
  { id: "privacy", label: "Privacy Policy", content: PRIVACY },
  { id: "shipping", label: "Shipping Policy", content: SHIPPING },
  { id: "return", label: "Return Policy", content: RETURN },
  { id: "cookie", label: "Cookie Policy", content: COOKIE },
];

export default function Policies() {
  const [activeId, setActiveId] = useState("privacy");

  useEffect(() => {
    const observers = sections.map(({ id }) => {
      const el = document.getElementById(id);
      if (!el) return null;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setActiveId(id);
        },
        { rootMargin: "-40% 0px -55% 0px" },
      );
      observer.observe(el);
      return observer;
    });
    return () => observers.forEach((o) => o?.disconnect());
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 py-16 flex gap-12">
      <aside className="hidden lg:block w-56 shrink-0">
        <div className="sticky top-8 space-y-1">
          <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-3 px-3">
            Policies
          </p>
          {sections.map(({ id, label }) => (
            <Link
              key={id}
              href={`#${id}`}
              className={cn(
                "block px-3 py-2 rounded-md text-sm transition-colors",
                activeId === id
                  ? "bg-primary/10 text-primary font-medium"
                  : "text-muted-foreground hover:text-foreground hover:bg-muted",
              )}
            >
              {label}
            </Link>
          ))}
        </div>
      </aside>

      <div className="flex-1 min-w-0 divide-y divide-border">
        {sections.map(({ id, content }) => (
          <section key={id} id={id} className="py-12">
            <DisplayMarkdown id={id} content={content} />
          </section>
        ))}
      </div>
    </div>
  );
}
